import { CssBaseline, ThemeProvider, createTheme, responsiveFontSizes } from "@mui/material"
import Typography from "./typography"
import palette from "./palette"
import customComponent from "./customComponent"


const ThemeSetUp = ({children}) =>{
    let theme = createTheme({
        typography : Typography,
        palette: palette,
    })
    theme = responsiveFontSizes(theme)
    theme.components = customComponent(theme)
    return(
        <ThemeProvider theme={theme}>
            <CssBaseline/>
            {children}
        </ThemeProvider>
    )
}
export default ThemeSetUp